export default "__VITE_ASSET__C4x5WChR__"